import styled from "styled-components";
import COLORS from "styles/colors";

export const Container = styled.div`
  width: 100%;
  /* border: 1px solid red; */
  .row {
    /* border: 1px solid blue; */
    margin: 10rem 9rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    :first-child {
      border-radius: 24px;
      background: ${({ background }) => background === "light" ? "#fbf8ff" : COLORS.primaryBackground};
      /* height: 320px; */
      display: flex;
      justify-content: center;
      align-items: center;

      .content {
        text-align: center;
        margin: 7rem 2rem;
        color: ${({ background }) => (background === "light" ? COLORS.black : COLORS.white)};
        span {
          @media all and (max-width: 768px) {
            width: 100%;
          }
          font-size: 1.4rem;
          line-height: 20px;
          font-weight: 400;
          display: inline-block;
          width: 70%;
          margin: 8px 0;
          :first-child {
            letter-spacing: 0.15em;
          }
          :last-child {
            font-size: 1.5rem;
          }
        }
        .header-text {
          font-size: 2.8rem;
          margin: 8px 0;
        }
        .btn {
          margin: 24px 0;
          white-space: nowrap;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          button {
            padding: 1.6rem 4.3rem;
            margin: 0.5rem 0.8rem;
            border-radius: 4px;
            font-family: "Cabinet Grotesk", sans-serif;
            @media all and (max-width: 768px) {
              width: 100%;
              margin-top: 10px;
            }
            /* transition: 0.3s; */
            :first-child {
              background: ${({ background }) => background === "light" ? COLORS.primaryBackground : COLORS.white};
              color: ${({ background }) => background === "light" ? COLORS.white : COLORS.primaryBackground};
            }
            :nth-of-type(2) {
              color: ${({ background }) => background === "light" ? COLORS.primaryBackground : COLORS.white};
              background: none;
              /*display: ${({ background }) => (background === "light" ? "inline-block" : "none")};*/
            }
            /* :hover {
              transform: translateY(-3px);
            } */
          }
        }
      }
    }

    .col {
      /* border: 1px solid red; */
      a .logo {
        display: inline;
        margin: 200px;
      }
      .icons {
        display: flex;
        align-items: center;
        /* margin-top: 5px; */

        svg {
          margin-right: 3rem;
          margin-bottom: 18px;
        }
      }
    }
    .col1 {
      margin-bottom: 20px;
    }
    .col2 {
      display: flex;
      flex-wrap: wrap;
      /* align-items: center; */
      .col {
        margin: 0 5.6rem;
        .head {
          font-size: 1.8rem;
          line-height: 28px;
          font-weight: 700;
          margin-bottom: 18px;
          display: inline-block;
        }
        ul li {
          /* text-decoration: none !important; */
          margin-bottom: 24px;
          font-size: 1.6rem;
          color: #3d3d3d;
          white-space: nowrap;
          cursor: pointer;

          :hover {
            /* font-weight: bold; */
            text-decoration: underline;
          }
          a {
            /* text-decoration: none !important; */
            color: ${COLORS.black};
            width: 130px;
            display: block;
          }
        }
        :last-child {
          margin-right: 0;
        }
        :first-child {
          margin-left: 0;
        }
        @media all and (max-width: 1024px) {
          margin-left: 0;
        }
      }
    }
    @media all and (max-width: 768px) {
      margin: 5rem 2rem;
    }

    .copyright {
      @media all and (max-width: 768px) {
        display: none;
      }
      &.mobile {
        display: none;
        @media all and (max-width: 768px) {
          display: block;
          width: 100%;
          font-size: 16px;
          text-align: center;
          color: #3d3d3d;
          margin: 4rem 0;
        }
      }
    }
  }
`;
